import { tsValidateString } from '@nu-art/ts-common';
import { PermissionDBGroup } from '../../consts.js';
import { validateProjectName } from '../../validators.js';
const Validator_ModifiableProps = {
    name: validateProjectName,
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString()
};
export const DBDef_PermissionProject = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'permissions--project',
    entityName: 'PermissionsProject',
    frontend: {
        group: PermissionDBGroup,
        name: 'project',
    },
    backend: {
        name: 'permissions--project'
    }
};
//# sourceMappingURL=db-def.js.map